import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function getDaysCourtesyAEAT (params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve(mock.getCompany)
    })
  } else {
    const req = {
      url: 'api/cifsempresa/getdatosvacaciones',
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      params
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { getDaysCourtesyAEAT }
